import L from "leaflet";
import moment from "moment";

export const formatDate = (dateValue, format = "MM/DD/YYYY HH:mm") => {
  if (!dateValue) {
    return "null";
  }
  
  // Handle all possible date formats
  let parsedDate;
  
  if (typeof dateValue === 'number') {
    // Already a number timestamp
    parsedDate = dateValue;
  } else if (typeof dateValue === 'string') {
    // Check if it's a numeric string (timestamp)
    if (!isNaN(dateValue) && dateValue.trim() !== '') {
      parsedDate = parseInt(dateValue);
    } else {
      // ISO string or other date format
      parsedDate = dateValue;
    }
  } else if (dateValue instanceof Date) {
    // Date object
    parsedDate = dateValue;
  } else {
    // Fallback for any other type
    parsedDate = dateValue;
  }
  
  const momentDate = moment(parsedDate);
  return momentDate.isValid() ? momentDate.format(format) : "Invalid date";
};

export const boundsToPoly = (bounds) => {
  // [] > []

  let latLng = [
    [bounds._southWest.lat, bounds._southWest.lng],
    [bounds._northEast.lat, bounds._northEast.lng],
  ];

  let ll = L.latLngBounds(latLng);
  let latlngs = [];

  latlngs.push(ll.getSouthWest()); // bottom left
  latlngs.push(ll.getSouthEast()); // bottom right
  latlngs.push(ll.getNorthEast()); // top right
  latlngs.push(ll.getNorthWest()); // top left
  //latlngs.push(ll.getSouthWest()) // bottom left (not required?)

  let resultPoly = new L.polygon(latlngs);

  //console.log('WWWTTTFFF??? (2): ', resultPoly)

  return resultPoly;
};

// parse map view bounds into coordinates for graphql backend
export const parseBounds = (bounds) => {
  const { _northEast, _southWest } = bounds;
  const coordinates = [
    [
      [_southWest.lng, _southWest.lat],
      [_northEast.lng, _southWest.lat],
      [_northEast.lng, _northEast.lat],
      [_southWest.lng, _northEast.lat],
      [_southWest.lng, _southWest.lat],
    ],
  ];
  return coordinates;
};

export const formatLatLngBounds = (bounds) => {
  return [
    [bounds._southWest.lat, bounds._southWest.lng],
    [bounds._northEast.lat, bounds._northEast.lng],
  ];
};

export const prepareOutboundCoordinates = (collection) => {
  // Change LAT/Lon to Lon/LAT
  //console.log('>>> OUTGOING to format: ', collection)
  let formatted = [];
  collection[0].forEach((ll) => {
    formatted.push([ll[1], ll[0]]); // reversed
  });
  //console.log('---reversED: ', formatted)
  return [formatted];
};

export const prepareIncomingCoordinates = (collection) => {
  // Change Lon/LAT to LAT/Lon
  //console.log('>>> INCOMING to format: ', collection)

  if (collection.length === 2) {
    // single LL array
    const coordinates = [...collection].reverse();
    return coordinates;
  }
  if (collection.length === 1) {
    // multiple LL arrays
    // .each
    //console.log('format TBD: ', collection)
  }
};

export const reversePolyForArea = (poly) => {
  // Not used (hopefully EVER!)
  //console.log('---reversing: ', poly)
  let formatted = [];
  poly[0].forEach((ll) => {
    formatted.push([ll.lng, ll.lat]); // reversed
  });
  //console.log('---reversED: ', formatted)
  return formatted;
  /*
    // NOT REVERSED
    let formatted = []
    console.log('poly to format...: ', poly)
    poly[0].forEach((ll) => {
        //console.log('LL: >>>>: ', ll)
        formatted.push([ll.lat, ll.lng]) // reversed
    })
    return [formatted]
    */
};

export const polyToBounds = (poly) => {
  // [] > []

  //var polygon = L.polygon(poly)
  //map.fitBounds(polygon.getBounds())
  //console.log('-------- PolyToBounds: ', poly.getBounds())

  return poly.getBounds();
};

export const polyToArea = (poly) => {
  // [] > INT

  //console.log('PolyToArea Incoming:::::: ', poly)
  //let ll_reversed = reversePolyForArea(poly)

  let area = L.GeometryUtil.geodesicArea(poly.getLatLngs()[0]);
  return parseInt(area / 100000);
};

export const toDecimalPlace = (val, dec) => {
  // INT, INT > INT

  return (Math.round(val * 100) / 100).toFixed(dec);
};

export const numberWithCommas = (x) => {
  // INT > STR

  let parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return parts.join(".");
};

const formatAMPM = (date) => {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + ":" + seconds + " " + ampm;

  return strTime;
};

export const displayTimestamp = (dateTime) => {
  // STR > STR
  //console.log('>>> TIME input: ', dateTime)
  const D = new Date(dateTime);
  const formatted =
    formatAMPM(dateTime) +
    " - " +
    (D.getMonth() + 1) +
    "/" +
    D.getDate() +
    "/" +
    D.getFullYear();

  //console.log('>>> TIME output: ', formatted )
  return formatted;
};

export const layersToLayer = (layers) => {
  // [] > {}
  // TBD
};
